import { NgModule } from '@angular/core';
import { PoPageLoginModule } from '@po-ui/ng-templates';
import { SharedModule } from './../../../shared/component/shared/shared.module';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [PoPageLoginModule, SharedModule],
  exports: [LoginComponent]
})
export class LoginModule {}
